/**
 * KunstPfote – Warenkorb-Tracking pro Upload-Session
 *
 * Sobald ein Produkt erfolgreich in den Warenkorb gelegt wurde (Horizon-Event „cart:update“ vom
 * product-form-component, ohne Fehler), meldet dieses Skript die Session an den n8n-Workflow
 * „Session added to cart“. Der setzt in Airtable (Tabelle Session) den Status auf „added to cart“
 * – außer die Session ist schon „ordered“ – und schickt Sven eine Telegram-Nachricht.
 *
 * Unabhängig vom Cookie-Consent: es werden nur Session-ID, Motiv und Varianten-ID gesendet.
 */
(() => {
  if (window.__kpCartTracking) return;
  window.__kpCartTracking = true;

  const ENDPOINT = 'https://n8n.kunstpfote.de/webhook/kp-session-cart';
  const UPLOAD_DATA_KEY = 'kunstpfote_uploads';

  function sessionId() {
    try {
      const d = JSON.parse(localStorage.getItem(UPLOAD_DATA_KEY) || 'null');
      if (d?.sessionId) return d.sessionId;
    } catch (e) {}
    try { return localStorage.getItem('kunstpfote_session') || ''; } catch (e) { return ''; }
  }

  document.addEventListener('cart:update', (e) => {
    const data = e.detail?.data || {};
    if (data.source !== 'product-form-component' || data.didError) return;

    const sid = sessionId();
    if (!/^sess_[a-f0-9]{16}$/.test(sid)) return;

    const form = e.target instanceof Element ? e.target : document;
    const skuInput = form.querySelector?.('.pf-sku-input') || document.querySelector('.pf-sku-input');

    const body = JSON.stringify({
      sessionId: sid,
      motiv: skuInput?.value || '',
      variantId: String(e.detail?.sourceId || ''),
      quantity: data.itemCount || 1,
    });

    try {
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true })
        .catch(() => {});
    } catch (err) {}
  });
})();
